module.exports = __webpack_public_path__ + "static/img/news.a6bdd6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news.png
// module id = jExj
// module chunks = 1